"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const RateModal_1 = __importDefault(require("../RateModal/RateModal"));
const defaultLabels_1 = require("../../utils/data/defaultLabels");
const CardsContext_1 = __importDefault(require("../../context/CardsContext"));
const tab_click_1 = require("../../utils/clickstream/tab-click");
const Tag = (0, styled_components_1.default)(constellation_1.StyledTag) `
    background-color: ${(0, constellation_1.token)('colors.green300')};
    border-radius: ${(0, constellation_1.token)('radii.md')}px;
    font-size: ${(0, constellation_1.token)('fontSizes.finePrint')}px;
    font-weight: 700;
    margin-bottom: ${(0, constellation_1.token)('spacing.sm')}px;
    padding: 2px ${(0, constellation_1.token)('spacing.xs')}px;
    text-decoration: none;
`;
const DescriptionBullets = ({ description }) => (react_1.default.createElement(constellation_1.List, null, description.map((element, i) => (react_1.default.createElement(constellation_1.List.Item, { paddingY: "xs", key: i }, element)))));
const RateContainer = ({ rate, apr, pointsPaid, pointsPaidDollar }) => (react_1.default.createElement(constellation_1.Box, { sx: {
        backgroundColor: '$colors.gray100',
        borderRadius: '$radii.sm',
        padding: '$spacing.md $spacing.sm',
    } },
    react_1.default.createElement(constellation_1.Flex, { display: "flex", gap: "md", marginBottom: "sm" },
        react_1.default.createElement(constellation_1.Flex, { display: "flex", flexDirection: "column" },
            react_1.default.createElement(constellation_1.Text, { fontColor: "gray600", fontType: "finePrint" }, "Rate"),
            react_1.default.createElement(constellation_1.Text, { fontColor: "textDark", fontType: "h5" },
                rate,
                "%")),
        react_1.default.createElement(constellation_1.Flex, { display: "flex", flexDirection: "column" },
            react_1.default.createElement(constellation_1.Text, { fontColor: "gray600", fontType: "finePrint" }, "APR"),
            react_1.default.createElement(constellation_1.Text, { fontColor: "textDark", fontType: "h5" },
                apr,
                "%"))),
    react_1.default.createElement(constellation_1.Flex, { display: "flex", flexDirection: "column" },
        react_1.default.createElement(constellation_1.Text, { fontColor: "gray600", fontType: "finePrint" }, "Points (cost)"),
        react_1.default.createElement(constellation_1.Text, { fontColor: "textDark", fontType: "h6" }, `${pointsPaid} ($${pointsPaidDollar})`))));
const RateCard = ({ apr, date, description = [], excerpt, highlight, modalTitle, monthlyPayment, pointsPaid, pointsPaidDollar, rate, title, }) => {
    const clickstream_displayed_txt = 'white_card_button';
    const { whiteCardsButtonText, showDesc, whiteCardButtonLink } = (0, react_1.useContext)(CardsContext_1.default);
    const btnLabel = whiteCardsButtonText || defaultLabels_1.whiteCardPlaceholders.buttonText;
    const onClickHandler = () => {
        (0, tab_click_1.triggerClickCardEvent)(`${clickstream_displayed_txt}_click_${title}`, btnLabel);
        if (whiteCardButtonLink) {
            window.location.href = whiteCardButtonLink;
        }
    };
    const onHoverHandler = (element, displayedTxt = '') => {
        (0, tab_click_1.triggerHoverCardElementEvent)(`${clickstream_displayed_txt}_hover_${title}`, element, displayedTxt);
    };
    return (react_1.default.createElement(constellation_1.Grid, { display: "grid", sx: { height: '100%' } },
        react_1.default.createElement(constellation_1.Card, { cardElevation: 0, cardType: "secondary", padding: "md", onMouseEnter: () => onHoverHandler('card') },
            react_1.default.createElement(constellation_1.Heading, { level: "4", fontColor: "black", fontType: "h4" }, title),
            react_1.default.createElement(Tag, null, highlight),
            react_1.default.createElement(RateContainer, { rate: rate, apr: apr, pointsPaid: pointsPaid, pointsPaidDollar: pointsPaidDollar }),
            showDesc && react_1.default.createElement(DescriptionBullets, { description: description }),
            react_1.default.createElement(constellation_1.Button, { onClick: onClickHandler, onMouseEnter: () => onHoverHandler('button', btnLabel), size: "md", as: "a", buttonType: "secondary", marginTop: "md", fluid: true }, btnLabel),
            react_1.default.createElement(constellation_1.Flex, { display: "flex", justifyContent: "center", marginTop: "sm" },
                react_1.default.createElement(RateModal_1.default, { modalTitle: modalTitle, apr: apr, date: date, rate: rate, pointsPaid: pointsPaid, monthlyPayment: monthlyPayment })))));
};
/** @component */
exports.default = RateCard;
